import React, { FC } from "react";
import { InputAdornment, TextField } from "@mui/material";

import {
  QualityCriteriaData,
  AllotmentPolicies,
} from "../../../../../../redux/slices/grainTracker/grainTrackerTypes";
import { stylesGW } from "../../../../grainWiseStylesMUIComponents";
import { DeleteConfirmButton } from "../../../../../libraryComponents/DeleteConfirmComponent";

type FormCurrentCharacteristicsParams = {
  AllotmentPolicies: AllotmentPolicies[];
  qualityCriteriaData: QualityCriteriaData[];
  t: (arg0: string) => string;
  setCriteriaValuesToDelete: (values: string[]) => void;
  selectedCriteriaToDelete: string[];
  updateBin: (token: string) => void;
  token: string;
};

const FormCurrentCharacteristics: FC<FormCurrentCharacteristicsParams> = ({
  AllotmentPolicies,
  qualityCriteriaData,
  t,
  setCriteriaValuesToDelete,
  selectedCriteriaToDelete,
  updateBin,
  token,
}) => {
  const characteristicsObject =
    AllotmentPolicies.length >= 1
      ? AllotmentPolicies?.map((values) => {
          const newObjectCharacteristics = {
            ...values,
            nameText: qualityCriteriaData.filter(
              (data) => data.id === values.storageQualityCriterionId,
            )[0]?.nameTextId?.text,

            instructionTextIdLocale: qualityCriteriaData.filter(
              (data) => data.id === values.storageQualityCriterionId,
            )[0]?.instructionTextIdLocale,

            unit: qualityCriteriaData.filter(
              (data) => data.id === values.storageQualityCriterionId,
            )[0]?.qualityCriterionUnit.SIUnit,

            symbolTextId: qualityCriteriaData.filter(
              (data) => data.id === values.storageQualityCriterionId,
            )[0]?.qualityCriterionUnit.symbolTextId.text,

            descriptionTextId: qualityCriteriaData.filter(
              (data) => data.id === values.storageQualityCriterionId,
            )[0]?.qualityCriterionUnit.descriptionTextId.text,
          };

          return newObjectCharacteristics;
        })
      : [];

  const finalValues = characteristicsObject;

  return (
    <div>
      {finalValues?.map((values) => {
        const arrayOfVarieties = values?.allotmentValueArray?.map((v) =>
          v.customerFacingTextId
            ? v.customerFacingTextId.text
            : v.defaultCustomerFacingText,
        );

        return (
          <div key={values.id} className="characteristics-form-container">
            <TextField value={values.nameText} disabled />
            {values.allotmentOperator === "<" ||
            values.allotmentOperator === ">" ? (
              <>
                <span className="should-be-existing-criteria">
                  {t("Grain_tracker.should-be")}
                </span>

                <span className="should-be-existing-criteria">
                  {values.allotmentOperator === "<"
                    ? t("Grain_tracker.strict-below")
                    : t("Grain_tracker.strict-above")}
                </span>

                <TextField
                  label={values?.descriptionTextId}
                  value={values?.allotmentValue}
                  disabled
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {values?.symbolTextId}
                      </InputAdornment>
                    ),
                  }}
                />
              </>
            ) : (
              <TextField
                disabled
                sx={stylesGW.FormCurrentCharacteristics.TextField}
                inputProps={{
                  style: stylesGW.FormCurrentCharacteristics.inputProps,
                }}
                value={arrayOfVarieties?.join(", ")}
              />
            )}

            <DeleteConfirmButton
              t={t}
              onConfirm={() => updateBin(token)}
              deleteText={t("Gran_tracker_bins.delete_allotment_criteria")}
              onSet={() => {
                setCriteriaValuesToDelete([
                  ...selectedCriteriaToDelete,
                  values.id,
                ] as any);
              }}
            />
          </div>
        );
      })}
    </div>
  );
};

export default FormCurrentCharacteristics;
